import React from 'react';
import { SpeakingPermissionArea, SpeakingPreparationArea, SpeakingRecordedArea, SpeakingRecorderState, SpeakingRecorderInitArea, SpeakingRecordingArea, SpeakingSubmittedRecordingArea } from '../../common';
import { jsx as _jsx } from "react/jsx-runtime";
export var SpeakingRecorderPreviewComponent = function SpeakingRecorderPreviewComponent(_ref) {
  var label = _ref.label,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      previewRecorder = _ref.previewRecorder;
  var recorderState = previewRecorder.recorderState,
      currentAttempts = previewRecorder.currentAttempts,
      prepTimeSec = previewRecorder.prepTimeSec,
      speakingTimeSec = previewRecorder.speakingTimeSec,
      minDurationSec = previewRecorder.minDurationSec,
      prepTimeLeft = previewRecorder.prepTimeLeft,
      speakingTimeLeft = previewRecorder.speakingTimeLeft,
      recordedDuration = previewRecorder.recordedDuration,
      audioUrl = previewRecorder.audioUrl,
      handleMicClick = previewRecorder.handleMicClick,
      handleSkipPreparation = previewRecorder.handleSkipPreparation,
      handleReRecord = previewRecorder.handleReRecord,
      handleSubmitClick = previewRecorder.handleSubmitClick,
      requestMicPermission = previewRecorder.requestMicPermission,
      stopRecording = previewRecorder.stopRecording;

  if (recorderState === SpeakingRecorderState.Permission) {
    return /*#__PURE__*/_jsx(SpeakingPermissionArea, {
      label: label,
      disabled: isDisabled,
      state: "requesting"
    });
  }

  if (recorderState === SpeakingRecorderState.PermissionDenied) {
    return /*#__PURE__*/_jsx(SpeakingPermissionArea, {
      label: label,
      disabled: isDisabled,
      state: "denied",
      onRetry: requestMicPermission
    });
  }

  if (recorderState === SpeakingRecorderState.Unsupported) {
    return /*#__PURE__*/_jsx(SpeakingPermissionArea, {
      label: label,
      disabled: isDisabled,
      state: "unsupported"
    });
  }

  if (recorderState === SpeakingRecorderState.Preparation) {
    return /*#__PURE__*/_jsx(SpeakingPreparationArea, {
      label: label,
      disabled: isDisabled,
      timeLeft: prepTimeLeft,
      totalSeconds: prepTimeSec,
      onSkip: handleSkipPreparation
    });
  }

  if (recorderState === SpeakingRecorderState.Recording) {
    return /*#__PURE__*/_jsx(SpeakingRecordingArea, {
      label: label,
      disabled: isDisabled,
      timeLeft: speakingTimeLeft,
      totalSeconds: speakingTimeSec,
      recordedDuration: recordedDuration,
      minimumDuration: minDurationSec,
      onStop: stopRecording
    });
  }

  if (recorderState === SpeakingRecorderState.Submitted && audioUrl) {
    return /*#__PURE__*/_jsx(SpeakingSubmittedRecordingArea, {
      label: label,
      audioUrl: audioUrl,
      duration: recordedDuration,
      audioId: "speaking-preview",
      useNativeAudio: true
    });
  }

  if (recorderState === SpeakingRecorderState.Recorded && audioUrl) {
    return /*#__PURE__*/_jsx(SpeakingRecordedArea, {
      label: label,
      disabled: isDisabled,
      audioUrl: audioUrl,
      duration: recordedDuration,
      audioId: "speaking-preview",
      useNativeAudio: true,
      onReRecord: handleReRecord,
      onSubmit: handleSubmitClick,
      canReRecord: previewRecorder.isUnlimitedAttempts || currentAttempts < previewRecorder.maxAttempts
    });
  }

  return /*#__PURE__*/_jsx(SpeakingRecorderInitArea, {
    label: label,
    disabled: isDisabled,
    preparationSeconds: prepTimeSec,
    speakingSeconds: speakingTimeSec,
    onStart: handleMicClick
  });
};